import { render } from "./CustomerEdit.vue?vue&type=template&id=3ce9cbf4&ts=true"
import script from "./CustomerEdit.vue?vue&type=script&lang=ts"
export * from "./CustomerEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__